var BufferFormatter = require('bufferformatter');
var Formatter = require('formatter');
var RenderReasons = require('renderreasons');
var IRCFormatter = require('ircformatter');

var ConnectionStatusView = Backbone.View.extend({
    tagName: 'div',
    className: 'connectionStatus',
    initialize: function (options) {
        this.visible = false;
        this.formatter = new BufferFormatter(this.model);
        
        this.model.bind('remove', this.remove, this);
    },
    events: {
        'click a.edit': 'clickEdit',
        'click a.back': 'clickBack',
        'click a.reconnect': 'clickReconnect',
        'click a.disconnect': 'clickDisconnect'
    },
    clickEdit: function (e) {
        e.preventDefault();
        this.model.connection.select();
        this.model.connection.trigger('showEdit');
    },
    clickBack: function (e) {
        e.preventDefault();
        this.model.connection.back();
    },
    clickReconnect: function (e) {
        e.preventDefault();
        this.model.connection.reconnect();
    },
    clickDisconnect: function (e) {
        e.preventDefault();
        this.model.connection.disconnect();
    },
    retryingText: function () {
        var timeout = this.model.connection.getRetryTimeout();
        var text = '';
        if (timeout) {
            if (this.model.connection.willRetry()) {
                text = 'Reconnecting ' + $.timeago(timeout, Formatter.PRECISION_STRINGS);
                var times = this.model.connection.getFailInfo('attempts');
                if (times > 1) {
                    var suffix = ["th", "st", "nd", "rd"];
                    var mod = times % 100;
                    var ordinal = times + (suffix[(mod-20)%10] || suffix[mod] || suffix[0]);
                    text += ' (' + this.formatter.escapeText(ordinal) + ' attempt)';
                }
            } else {
                text = 'Reconnecting…';
            }
        }
        return text;
    },
    render: function () {
        var status = this.model.connection.getStatus();
        if (this.retryHandle && status != 'waiting_to_retry') {
            this.clearRetryHandle();
        }
        
        var text = '';
        switch (status) {
        case 'waiting_to_retry':
            if (this.model.connection.getFailInfo('reason') == 'reconnecting') {
                text += 'Reconnecting…';
            } else {
                text += this.retryingText();

                this.clearRetryHandle();
                this.retryHandle = setInterval(_.bind(function () {
                    var retrying = this.retryingText();
                    this.renderText(retrying);
                    if (!retrying) {
                        this.clearRetryHandle();
                    }
                }, this), 1000);
            }
            break;
        case 'queued':
            text += 'Connection queued; waiting our turn…';
            break;
        case 'connecting':
            text += 'Connecting to ' + this.formatter.escapeText(this.model.connection.get('hostname')) + '…';
            break;
        case 'connected':
            text += 'Connected; handshaking…';
            break;
        case 'connected_joining':
            text += 'Connected; setting up…';
            break;
        case 'quitting':
            text += 'Quitting…';
            break;
        case 'ip_retry':
            var error = this.model.connection.getFailInfo('error');
            var ip = this.model.connection.getFailInfo('ip');
            text += 'Connecting';
            if (ip) {
                text += ' to ' + this.formatter.escapeText(ip);
            }
            text += ' failed';
            if (error) {
                text += ' (' + this.formatter.escapeText(error) + ')';
            } else {
                text += ',';
            }
            text += ' resolving a new IP…';
            break;
        case 'disconnected':
            if (!this.model.connection.isFailed()) {
                text += 'Disconnected';
            }
            break;
        case 'connected_ready':
            if (this.model.connection.focusOnMakeBuffer == '*') {
                text += 'Connected; waiting to join…';
            } else if (this.model.connection.focusOnMakeBuffer && this.formatter.linker.isChannelName(this.model.connection.focusOnMakeBuffer)) {
                text += 'Connected; waiting to join ' + this.formatter.escapeText(this.model.connection.focusOnMakeBuffer) + '…';
            }
            break;
        }
        return this.renderText(text);
    },
    isVisible: function () {
        return this.visible;
    },
    show: function () {
        if (!this.isVisible()) {
            $(this.el).addClass(this.className + '--show');
            this.visible = true;
        }
        return this;
    },
    hide: function () {
        if (this.isVisible()) {
            $(this.el).removeClass(this.className + '--show');
            this.visible = false;
        }
        return this;
    },
    renderText: function (status) {
        var html = '';
        var htmlLink;
        var failure = this.model.connection.isFailed();
        var restricted;
        $(this.el).removeClass().addClass(this.className).toggleClass(this.className + '--show', this.isVisible());
        if (failure) {
            $(this.el).addClass('fail');
            var failInfo = this.model.connection.getFailInfo();
            if (failInfo.type == 'connecting_restricted') {
                html += RenderReasons.renderRestricted(failInfo.reason);
                restricted = true;
            }
            if (!restricted && !this.model.connection.badRetry()) {
                html += 'Disconnected';
            }
            if (failInfo.type == 'connection_blocked') {
                html += ' - Connections to this server have been blocked';
            }
            if (failInfo.type == 'killed') {
                html += ' - Killed';
                if (failInfo.reason && failInfo.reason != '()') {
                    html += ': ' + this.formatter.escapeText(IRCFormatter.strip(failInfo.reason));
                }
            } else if (failInfo.reason && !restricted) {
                if (!this.model.connection.badRetry()) {
                    html += ': ';
                }
                if (failInfo.reason == 'ssl_verify_error') {
                    html = '<i class="fa fa-warning"></i> ' + html;
                    html += 'Strict transport security error';
                    var verifyError = RenderReasons.renderSSLVerify(failInfo.ssl_verify_error);
                    if (verifyError) {
                        html += ': ' + verifyError;
                    }
                } else {
                    if (failInfo.type == 'connecting_failed') {
                        html += 'Failed to connect - ';
                    }
                    html += this.formatter.escapeText(IRCFormatter.strip(RenderReasons.render(failInfo.reason)));
                    if (this.model.connection.badRetry()) {
                        html += '; ';
                    }
                }
            }
            if ((failInfo.type == 'connecting_failed' || failInfo.type == 'socket_closed') && !this.model.connection.badRetry()) {
                var failedHtml = '';
                var htmlLinkClass = 'edit';
                var htmlLinkText = 'Check your host, port and ssl settings';
                var htmlLinkHref = '';
                var htmlLinkExtra = '';
                if (this.model.connection.isSlackUpgradable()) {
                    failedHtml += '<b>This Slack IRC gateway is closing down, but you can upgrade to a new integration</b> ';
                    htmlLinkClass = 'upgradeSlack';
                    htmlLinkText = 'Read the announcement and upgrade instructions';
                    htmlLinkHref = 'https://blog.irccloud.com/slack-integration/';
                    htmlLinkExtra = ' target="_blank"';
                } else if (this.model.connection.isSuspiciousPort()) {
                    failedHtml += '<b>You’re trying to connect ';
                    failedHtml += this.model.connection.isSSL() ? 'via' : 'without';
                    failedHtml += ' SSL on port ' + this.model.connection.getPort() + '.</b> ';
                }
                if (!this.model.connection.isTeamServer() && this.model.connection.isSuspiciousHostname()) {
                    failedHtml += '<b>Your hostname looks invalid: ' + this.formatter.escapeText(this.model.connection.get('hostname')) + '</b> ';
                }
                htmlLink = {
                    className: htmlLinkClass,
                    text: htmlLinkText,
                    href: htmlLinkHref,
                    extra: htmlLinkExtra
                };
                htmlLink.html = '<a href="' + htmlLinkHref + '" class="' + htmlLink.className + '"'
                    + htmlLink.extra + '>' + htmlLink.text + '</a>';
                if (!failedHtml) {
                    htmlLink.html = ' (' + htmlLink.html + ')';
                    html += htmlLink.html;
                } else {
                    failedHtml += htmlLink.html;
                    html += ' (' + failedHtml + ')';
                }
            }
            if (!this.model.connection.badRetry() && (status || failInfo.give_up)) {
                html += '; ';
            }
            if (failInfo.give_up) {
                html += 'Gave up retrying';
                if (status) {
                    html += '; ';
                }
            }
        }
        var away = this.model.connection.get('away');
        if (this.model.connection.isConnected() && away) {
            $(this.el).addClass('away');
            var text = 'Away';
            if (away !== true && away.toLowerCase() != 'away') {
                text += ' (' + away + ')';
            }
            html += '<a href="#" class="back"><span class="back">Click to come back (or type /back)</span> ' + this.formatter.render(text);
            if (status) {
                html += ' (' + status + ')';
            }
            html += '</a>';
        } else {
            if (this.model.connection.isDisconnected()) {
                var currentHTML = html;
                if (htmlLink) {
                    $(this.el).addClass(htmlLink.className);
                    html = '<a href="' + htmlLink.href + '" class="' + htmlLink.className + '"'
                        + htmlLink.extra + '>' + '<span class="' + htmlLink.className + '">' +
                        htmlLink.text + '</span> ';
                } else if (this.model.connection.badRetry()) {
                    $(this.el).addClass('disconnect');
                    html = '<a href="/" class="disconnect"><span class="disconnect">Click to disconnect (or type /disconnect)</span> ';
                } else if (restricted) {
                    $(this.el).addClass('upgrade');
                    html = '<a href="/?/upgrade" class="upgrade"><span class="upgrade">Click to see upgrade options</span> ';
                } else {
                    $(this.el).addClass('reconnect');
                    html = '<a href="/" class="reconnect"><span class="reconnect">Click to reconnect (or type /reconnect)</span> ';
                }
                if (currentHTML) {
                    if (htmlLink) {
                        html += currentHTML.replace(htmlLink.html, '');
                    } else {
                        html += currentHTML;
                    }
                }
                if (status) {
                    html += status;
                }
                html += '</a>';
            } else if (status) {
                html += status;
            }
        }

        html = this.chanMembersFailed(html);

        $(this.el).html(html);
        return html ? this.show() : this.hide();
    },
    chanMembersFailed: function (html) {
        var chan_members_failed = this.model.connection.get('chan_members_failed');
        if (chan_members_failed) {
            var suffix = '';
            if (html) {
                suffix = '; ';
            }
            var msg;
            if (chan_members_failed === 'timeout') {
                msg = 'The system is overloaded and functionality may be slow or unavailable.';
            } else {
                msg = 'The system is having problems and some functionality may not be working properly.';
            }
            if (!this.model.session.ent()) {
                msg += ' Check <a href="https://bsky.app/profile/irccloud.com" target="_blank" rel="noreferrer">Bluesky</a> for status updates.';
            }
            html = msg + suffix + html;
            $(this.el).addClass('chan_members_failed');
        }
        return html;
    },
    clearRetryHandle: function () {
        clearInterval(this.retryHandle);
        this.retryHandle = null;
    }
});


module.exports = ConnectionStatusView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/connectionstatusview.js
// module id = OC/i
// module chunks = 1